module.exports = __webpack_public_path__ + "img/funnel-nedbank.76918fc1.png";